import ReplyDeleteModal from './ReplyDeleteModal';

export default ReplyDeleteModal;
